export default {
  GENERAL: 'general',
  SEO: 'seo',
  OPEN_GRAPH: 'open_graph',
  CUSTOM_CODE: 'custom_code',
};
